import GetOutlookMigrationDiagnosticsRequest from 'owa-service/lib/contract/GetOutlookMigrationDiagnosticsRequest';
import GetOutlookMigrationDiagnosticsResponse from 'owa-service/lib/contract/GetOutlookMigrationDiagnosticsResponse';
import getOutlookMigrationDiagnosticsRequest from 'owa-service/lib/factory/getOutlookMigrationDiagnosticsRequest';
import getOutlookDotComMigrationDiagnosticsOperation from 'owa-service/lib/operation/getOutlookDotComMigrationDiagnosticsOperation';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';

/**
 * Helper method that creates the GetOutlookMigrationDiagnosticsRequest body
 * @return GetOutlookMigrationDiagnosticsRequest
 */
function createRequestBody(): GetOutlookMigrationDiagnosticsRequest {
    let sessionSettings = getUserConfiguration().SessionSettings;
    let emailAddresses = [
        <EmailAddressWrapper>{
            EmailAddress: sessionSettings.UserEmailAddress,
            Name: sessionSettings.UserDisplayName,
            RoutingType: 'SMTP',
        },
    ];
    return getOutlookMigrationDiagnosticsRequest({ SendReportToAddresses: emailAddresses });
}

/**
 * Get rules diagnostics report
 * @return GetOutlookMigrationDiagnosticsRequest
 */
export default function getOutlookMigrationDiagnosticsService(): Promise<
    GetOutlookMigrationDiagnosticsResponse
> {
    let requestBody = createRequestBody();
    return getOutlookDotComMigrationDiagnosticsOperation(requestBody);
}
